import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import { useNavigate } from 'react-router-dom';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DescriptionIcon from '@mui/icons-material/Description';
import BallotIcon from '@mui/icons-material/Ballot';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ContactsIcon from '@mui/icons-material/Contacts';
import EmailIcon from '@mui/icons-material/Email';
import Groups3Icon from '@mui/icons-material/Groups3';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const ChatEntityReference = ({ reference, isOwn }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const navigate = useNavigate();

  const typeConfig = {
    project: {
      icon: AccountTreeIcon,
      path: '/projects/management',
      color: colors.colorPool?.[0] || '#00A5E3',
    },
    company_lead: {
      icon: Groups3Icon,
      path: '/leads/company',
      color: colors.colorPool?.[7] || '#9B59B6',
    },
    person_lead: {
      icon: Groups3Icon,
      path: '/leads/person',
      color: colors.colorPool?.[7] || '#9B59B6',
    },
    invoice: {
      icon: ReceiptIcon,
      path: '/invoices',
      color: colors.colorPool?.[3] || '#FF5768',
    },
    offer: {
      icon: DescriptionIcon,
      path: '/offers',
      color: colors.colorPool?.[4] || '#FFA23A',
    },
    order: {
      icon: BallotIcon,
      path: '/orders',
      color: colors.colorPool?.[1] || '#8DD7BF',
    },
    company: {
      icon: ApartmentIcon,
      path: '/companies',
      color: colors.colorPool?.[6] || '#CFF800',
    },
    contact: {
      icon: ContactsIcon,
      path: '/contacts',
      color: colors.colorPool?.[2] || '#FF96C5',
    },
    imap_email: {
      icon: EmailIcon,
      path: '/emails',
      color: colors.colorPool?.[5] || '#FFD872',
    },
  };

  const config = typeConfig[reference.type] || typeConfig.project;
  const Icon = config.icon;

  const handleClick = (e) => {
    e.stopPropagation();
    navigate(`${config.path}/${reference.referenceableId}`);
  };

  return (
    <Box
      onClick={handleClick}
      className="flex items-center gap-1.5 pl-2 pr-2.5 py-1 rounded-lg cursor-pointer transition-all group"
      sx={{
        backgroundColor: `${config.color}15`,
        border: `1px solid ${config.color}30`,
        '&:hover': {
          backgroundColor: `${config.color}25`,
          border: `1px solid ${config.color}50`,
        },
      }}
    >
      <Icon sx={{ fontSize: 14, color: config.color }} />
      <Typography
        variant="caption"
        sx={{
          color: config.color,
          fontWeight: 500,
          fontSize: '0.72rem',
          lineHeight: 1.2,
        }}
      >
        {reference.label || `#${reference.referenceableId}`}
      </Typography>
      <OpenInNewIcon
        className="opacity-0 group-hover:opacity-100 transition-opacity"
        sx={{ fontSize: 10, color: config.color, ml: -0.5 }}
      />
    </Box>
  );
};
